import React, { useState, useContext, useEffect } from 'react'
import { TabPanel, TabView } from 'primereact/tabview';
//**************************** Componentes Generales*************************************************** */
import ListadoRegistroFacturas from './TabsRegistroFacturas/ListadoRegistroFacturas';
import DetallesRegistroFacturas from './TabsRegistroFacturas/DetallesRegistroFacturas';
//****************************************************************************************************** */
import {CuentasPorPagarLang} from './Lang/CuentasPorPagarLang'
import { getLabel } from '../../../Services/Language/LanguageService';
import { ConfigContext } from '../../../Context/ConfigContext/ConfigContext';
import { setTitlePage } from '../../../Services/Config/ConfigService';
const RegistroFacturasScreen = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const { config } = useContext(ConfigContext);

    useEffect(() => {
       setTitlePage(getLabel(CuentasPorPagarLang,'TituloFacturas', config?.language))
    },[])

    return (
        <div>
            <TabView className="col-12 homeTabView" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header={getLabel(CuentasPorPagarLang,'TituloFacturas', config?.language)}>
                    <ListadoRegistroFacturas />
                </TabPanel >
                <TabPanel header={getLabel(CuentasPorPagarLang,'TituloDetalles', config?.language)}>
                    <DetallesRegistroFacturas />
                </TabPanel >

            </TabView>

        </div>
    )
}

export default RegistroFacturasScreen


